export const guideContentByKey = {
  main: {
    dashboard: {
      title: "Dashboard",
      what: "Veja métricas e tendências do seu atendimento, clientes e vendas (quando habilitado).",
      steps: ["Escolha o período", "Leia os indicadores principais", "Clique nos cards/gráficos para aprofundar"],
      tips: ["Compare períodos semelhantes (ex.: semana vs semana)."],
    },
    chat: {
      title: "Atendimento (Chat)",
      what: "Central de conversas para atender clientes em múltiplos canais.",
      steps: ["Use busca e filtros para achar a solicitação", "Abra a conversa", "Responda e atualize o status quando necessário"],
      tips: ["Use 'Meu dia' para focar no que está com você agora."],
    },
    sales_pipeline: {
      title: "Pipeline de Vendas",
      what: "Acompanhe oportunidades e mova cards entre etapas do funil.",
      steps: ["Aplique filtros", "Abra um card para detalhes", "Arraste para mudar de etapa"],
      tips: ["Padronize etapas para manter o time alinhado."],
    },
    clients: {
      title: "Clientes",
      what: "Cadastre e consulte informações do cliente e o histórico.",
      steps: ["Busque pelo nome/telefone/email", "Abra o detalhe", "Atualize dados quando necessário"],
      tips: ["Mantenha dados básicos corretos para melhorar automações e relatórios."],
    },
    surveys: {
      title: "Pesquisas",
      what: "Crie pesquisas, publique links e acompanhe resultados/analytics.",
      steps: ["Crie ou edite uma pesquisa", "Publique/compartilhe", "Acompanhe analytics"],
      tips: ["Use perguntas curtas e objetivas para aumentar a taxa de resposta."],
    },
    awareness: {
      title: "Níveis de consciência",
      what: "Organize solicitações por estágio (ex.: frio/morno/quente) e avance conforme o atendimento evolui.",
      steps: ["Abra o quadro", "Arraste cards entre etapas", "Use filtros para focar no que importa"],
      tips: ["Defina critérios claros para cada etapa (o que significa estar em cada uma)."],
    },
    products: {
      title: "Produtos",
      what: "Cadastre e mantenha seu catálogo para vitrine, pedidos e integrações.",
      steps: ["Crie/edite produtos", "Ajuste preço/estoque", "Organize com categorias e conteúdos quando aplicável"],
      tips: ["Comece pelos itens mais vendidos para ganhar tração rápido."],
    },
  },
  settings: {
    companies: {
      title: "Empresas",
      what: "Gerencie empresas do workspace e quem pode acessar cada uma.",
      steps: ["Cadastre/edite empresas", "Ative/desative quando necessário", "Revise acessos por empresa"],
    },
    users: {
      title: "Usuários",
      what: "Convide e administre usuários e seus acessos.",
      steps: ["Convide usuários", "Atribua cargos/permissões", "Revise acessos regularmente"],
      tips: ["Dê acesso mínimo necessário por função."],
    },
    chatbot: {
      title: "Chatbots",
      what: "Crie e ajuste fluxos automáticos (menus, respostas, ações).",
      steps: ["Crie um chatbot", "Edite o fluxo (canvas/árvore)", "Simule antes de publicar"],
    },
    agents: {
      title: "Agentes de IA",
      what: "Configure assistentes de IA com bases de conhecimento e acompanhe uso.",
      steps: ["Crie/edite um agente", "Adicione documentos e URLs", "Monitore analytics e logs"],
      tips: ["Comece com um agente para um caso específico (ex.: FAQ) antes de expandir."],
    },
    positions: {
      title: "Cargos e permissões",
      what: "Defina o que cada cargo pode ver e fazer no sistema.",
      steps: ["Crie cargos", "Marque permissões por recurso", "Atribua cargos aos usuários"],
    },
    channels: {
      title: "Canais",
      what: "Conecte WhatsApp, e-mail, website, telefonia e outros canais.",
      steps: ["Crie/edite um canal", "Conecte/valide (QR/OAuth/domínio)", "Teste envio/recebimento"],
      tips: ["Conclua a conexão antes de treinar o time para evitar falhas na operação."],
    },
    integrations: {
      title: "Integrações",
      what: "Configure integrações e credenciais para conectar serviços externos.",
      steps: ["Cadastre a integração", "Teste conexão", "Acompanhe status e erros"],
    },
    workspace_i18n: {
      title: "Idiomas",
      what: "Personalize textos do workspace por idioma (quando aplicável).",
      steps: ["Escolha o idioma", "Ajuste textos necessários", "Valide telas principais"],
    },
    types: {
      title: "Tipos",
      what: "Padronize classificações (tipo/subtipos) para organizar e automatizar solicitações.",
      steps: ["Crie/edite tipos e subtipos", "Defina padrões por canal (se usar)", "Use em automações e roteamentos"],
    },
    categories: {
      title: "Categorias",
      what: "Organize produtos e conteúdos em categorias (hierarquia).",
      steps: ["Crie categorias", "Organize em níveis", "Vincule aos itens do catálogo"],
    },
    automation_rules: {
      title: "Regras de automação",
      what: "Automatize ações com base em eventos (status, tipo, canal, etc.).",
      steps: ["Crie a regra", "Simule/valide", "Ative e monitore"],
    },
    antifraud_methods: {
      title: "Antifraude",
      what: "Configure provedores e mapeamentos de decisão para seus fluxos.",
      steps: ["Cadastre o método", "Configure credenciais", "Mapeie decisões para Tipos/Subtipos"],
    },
    payment_methods: {
      title: "Formas de pagamento",
      what: "Defina as formas aceitas e mapeamentos de status quando aplicável.",
      steps: ["Cadastre a forma", "Ative/desative", "Configure mapeamentos de status para Tipos/Subtipos"],
    },
    delivery_methods: {
      title: "Métodos de entrega",
      what: "Configure opções de entrega (frete, retirada, transportadoras).",
      steps: ["Cadastre o método", "Defina regras/regiões", "Teste cotações quando aplicável"],
    },
    awareness_stages: {
      title: "Etapas dos níveis de consciência",
      what: "Personalize as etapas do quadro de níveis de consciência.",
      steps: ["Crie/edite etapas", "Ordene como o time trabalha", "Revise critérios por etapa"],
    },
    coupons: {
      title: "Cupons",
      what: "Crie cupons de desconto e controle validade/uso.",
      steps: ["Crie o cupom", "Defina regras e validade", "Acompanhe uso"],
    },
    banners: {
      title: "Banners",
      what: "Gerencie banners e destaques de vitrine (quando aplicável).",
      steps: ["Crie/edite o banner", "Defina período e visibilidade", "Publique e revise"],
    },
    contents: {
      title: "Conteúdos",
      what: "Crie conteúdos e páginas auxiliares (quando aplicável).",
      steps: ["Crie/edite o conteúdo", "Publique/despublique", "Revise links e consistência"],
    },
  },
  topbar: {
    notifications: {
      title: "Notificações",
      what: "Acompanhe alertas e novidades sem perder o contexto do que está fazendo.",
      steps: ["Clique no sino", "Abra a notificação", "Volte para a tela que estava usando"],
      tips: ["Ajuste preferências de som/desktop quando disponíveis."],
    },
    themes: {
      title: "Temas (aparência)",
      what: "Troque o tema para melhorar conforto visual (claro/escuro e variações).",
      steps: ["Clique no ícone de tema", "Escolha uma opção", "Siga usando normalmente"],
    },
    platform_ai: {
      title: "Assistente da plataforma (IA)",
      what: "Tire dúvidas e obtenha apoio dentro do contexto do sistema.",
      steps: ["Clique no ícone da IA", "Digite sua pergunta", "Revise a resposta e aplique na rotina"],
      tips: ["Use termos do menu (ex.: 'canais', 'pagamento') para respostas mais objetivas."],
    },
    profile_menu: {
      title: "Menu do perfil",
      what: "Acesse perfil, ajuda, faturamento (se habilitado) e console (se master).",
      steps: ["Clique no avatar", "Escolha a opção desejada", "Conclua a ação e volte"],
    },
  },
};

